/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2024-01-16 10:15:02
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\besSer\WMmanagement\scrap.js
 */
export const queryPage = "/icps/system/sign/goodService/materialsScrap/queryPage";
export const saveOrUpdate = "/icps/system/sign/goodService/materialsScrap/saveOneResord";
import request from "@/utils/request";
/**获取周材名列表*/
export function queryNameList(params) {
  return request({
    url: "/icps/system/sign/goodService/repertoryManage/queryNameList",
    method: "get",
    params,
  });
}
/**:获取规格和类型列表*/
export function querySpecification(data) {
  return request({
    url: "/icps/system/sign/goodService/repertoryManage/querySpecification",
    method: "post",
    data,
  });
}
/**:修改报废记录*/
export function updateResord(data) {
  return request({
    url: "/icps/system/sign/goodService/materialsScrap/updateResord",
    method: "post",
    data,
  });
}
/**:保存报废记录*/
export function saveOneResord(data) {
  return request({
    url: "/icps/system/sign/goodService/materialsScrap/saveOneResord",
    method: "post",
    data,
  });
}
